import { AiItineraryBuilder } from "../../../../Trips"
import { useTripDetailsOutletContext } from "./_trip-details-context"
import { Helmet } from "react-helmet-async"
import { Navigate } from "@sembark-travel/ui-router"
import { generatePath } from "../../../../router-utils"
import { useParams } from "../../../../router"
import { Spinner } from "@sembark-travel/ui-base"
import { useHasFeatureFlag } from "../../../../Auth"

export default function AiItineraryBuilderPage() {
	const { trip } = useTripDetailsOutletContext()
	const { tripId } = useParams("/trips/:tripId/ai-itinerary-builder")
	const hasAIItineraryBuilder = useHasFeatureFlag("ai_itinerary_builder")

	return (
		<>
			<Helmet>
				<title>AI Itinerary Builder</title>
			</Helmet>
			{!trip ? (
				<Spinner alignCenter padding="4" />
			) : !hasAIItineraryBuilder ||
			  trip.is_locked ||
			  trip?.latest_given_quote ||
			  trip?.cancellation_reason ? (
				<Navigate to={generatePath("/trips/:tripId", { tripId })} replace />
			) : (
				<AiItineraryBuilder trip={trip} />
			)}
		</>
	)
}
